export const LIST_HEADER_SEARCH_FIRMS_LABEL = 'Search firms';
export const LIST_HEADER_SEARCH_COMPANIES_LABEL = 'Search companies';
